import { render, staticRenderFns } from "./personnelCommun-add-or-update.vue?vue&type=template&id=9e2ba61a&scoped=true"
import script from "./personnelCommun-add-or-update.vue?vue&type=script&lang=js"
export * from "./personnelCommun-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2ba61a",
  null
  
)

export default component.exports